import comingSoon from '../../assets/images/comingSoon.svg';
const RecruitPortal = () => {
	return (
		<div className="flex justify-center">
			<img className="w-1/3" src={comingSoon} alt="" />
		</div>
	);
};
export default RecruitPortal;
